<template>
  <div v-show="show">
    <div class="row">

      <b-form-group class="col-12 col-sm-8 col-md-8 col-lg-8"
        label="Endereço"
        label-for="address">
        <b-form-input id="address"
          type="text"
          :disabled="disabled"
          :value="form.address.address"
          @input="updateForm('address', arguments[0])"
          placeholder="Logradouro"
          :class="{
            'is-invalid': form.errors.has('address.address')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-4 col-md-4 col-lg-4"
        label="Número"
        label-for="number">

        <b-form-input id="number"
          type="text"
          :disabled="disabled"
          :value="form.address.number"
          @input="updateForm('number', arguments[0])"
          placeholder="Número"
          :class="{
            'is-invalid': form.errors.has('address.number')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="Complemento"
        label-for="complement">

        <b-form-input id="complement"
          type="text"
          :disabled="disabled"
          :value="form.address.complement"
          @input="updateForm('complement', arguments[0])"
          placeholder="Complemento"
          :class="{
            'is-invalid': form.errors.has('address.complement')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="Bairro"
        label-for="neighborhood">

        <b-form-input id="neighborhood"
          type="text"
          :disabled="disabled"
          :value="form.address.neighborhood"
          @input="updateForm('neighborhood', arguments[0])"
          placeholder="Bairro"
          :class="{
            'is-invalid': form.errors.has('address.neighborhood')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="CEP"
        label-for="zipcode">

        <b-form-input id="zipcode"
          type="text"
          :disabled="disabled"
          :value="form.address.zipcode"
          @input="updateForm('zipcode', arguments[0])"
          placeholder="CEP"
          v-mask="'##.###-###'"
          :class="{
            'is-invalid': form.errors.has('address.zipcode')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="Cidade"
        label-for="city_id">
        <multiselect
          @search-change="searchCities"
          :loading="processingCities"
          :options="cities"
          v-model="city"
          track-by="id"
          label="name"
          placeholder="Pesquisar..."
          selectedLabel="Selecionado"
          :limitText="count => `e ${count} mais`"
          :limit="10"
          :hide-selected="false"
          :show-no-results="false"
          open-direction="bottom"
          :internal-search="false"
          :close-on-select="true"
          :clear-on-select="true"
          :showLabels="false"
          :disabled="disabled">
          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear"
              v-if="city !== null"
              @mousedown.prevent.stop="clearCity(props.search)">

              <i class="fa fa-times"></i>
            </div>
          </template>
        </multiselect>
      </b-form-group>
    </div>
  </div>
</template>
<script>
  import { get, set, clone, debounce, isEmpty } from 'lodash'
  import { resolveHTTP } from '@/services/api'

  export default {
    props: {
      form: {
        type: [Object],
        required: true
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        show: true,
        options: [],

        processingCities: false,
        selectedCity: null,
        citiesApi: null,
        cities: [],

        empty: {
          id: null,
          zipcode: '',
          address: '',
          number: '',
          complement: '',
          neighborhood: '',
          city_id: null,
          status: true,
          maps: ''
        }
      }
    },

    watch: {
      form: {
        handler (nextForm) {
          const self = this

          self.show = false
          self.$nextTick(() => { self.show = true })

          if (isEmpty(nextForm.address)) {
            self.$nextTick(() => {
              self.form.address = clone(self.empty)
              self.selectedCity = null
              self.show = true
            })
          }
        },
        deep: true
      }
    },

    computed: {
      city: {
        get () {
          return this.selectedCity || get(this.form, 'address.city', null)
        },

        set (value) {
          this.selectedCity = value
          this.updateForm('city_id', get(value, 'id', null))
        }
      }
    },

    methods: {
      updateForm (field, value) {
        set(this.form, `address.${field}`, value)
      },

      searchCities (searchQuery) {
        return this.debouncedSearchCities(searchQuery, this)
      },

      debouncedSearchCities: debounce((searchQuery, context) => {
        const self = context

        if (searchQuery) {
          self.processingCities = true

          self.citiesApi.index({ params: {
            per_page: 50,
            search: searchQuery
          }}).then((res) => {
            self.processingCities = false
            self.cities = res.data.collection
          })
        }
      }, 500, { 'maxWait': 1000 }),

      clearCity (search) {
        this.city = null
      }
    },

    mounted () {
    },

    created () {
      const self = this

      self.selectedCity = get(self.form, 'address.city', null)
      self.citiesApi = resolveHTTP('/geo/cities')

      if (isEmpty(self.form.address)) {
        self.form.address = clone(self.empty)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/Geo/AddressFields.vue